export default "__VITE_ASSET__ChaYpOrU__"